export default __webpack_public_path__ + "baa2844069cc1dfcb08e86eaaf14af51.png";